<template>
  <div class="panel">
    <h3 class="panel-title">订单记录</h3>
    <div id="comment-list" class="comment-list">
      <div v-for="(com, index) in salesOrderCommentList" class="comment" :key="index">
        <h5 class="c_name">
          {{com.createdBy.name}}
          <Time class="c_created_at" :time="com.createdAt" />
        </h5>
        <span class="c_content">{{com.content}}</span>
      </div>
    </div>

    <div class="input-block">
      <textarea
        v-model="inputText"
        wrap="soft"
        autocomplete="off"
        spellcheck="false"
        placeholder="输入评论..."
        rows="3"
        class="ivu-input textarea-block"
      ></textarea>
      <Button
        :disabled="inputText === null || inputText.trim() === ''"
        @click="sendComment"
        size="small"
        style="float: right; margin-right: 8px;"
      >发送</Button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";

export default {
  name: "CommentPanel",
  data() {
    return {
      inputText: null,
      query: {
        salesOrder: null,
        skip: 0,
        limit: 40,
      },
    };
  },
  computed: {
    ...mapState({
      salesOrderCommentList: (state) =>
        state.salesOrderComment.salesOrderCommentList,
    }),
  },
  methods: {
    ...mapActions({
      getSalesOrderCommentList:
        "salesOrderComment/getSalesOrderCommentListAction",
      createSalesOrderComment:
        "salesOrderComment/createSalesOrderCommentAction",
    }),
    async loadData(payload) {
      this.query.salesOrder = payload.salesOrder;
      await this.getSalesOrderCommentList({
        salesOrder: this.query.salesOrder._id,
      });
      this.scrollToEnd();
    },
    async sendComment() {
      try {
        const newComment = await this.createSalesOrderComment({
          salesOrder: this.query.salesOrder._id,
          content: this.inputText.trim(),
        });
        this.commentList.push(newComment);
        this.inputText = null;
        this.scrollToEnd();
      } catch (error) {}
    },
    scrollToEnd() {
      this.$nextTick(() => {
        var container = this.$el.querySelector("#comment-list");
        container.scrollTop = container.scrollHeight;
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.panel
  background-color #f7f7f7
  border-radius 4px
  width 100%
  height 100%

.panel-title
  width 100%
  padding 12px 12px 4px 12px

.comment-list
  width 100%
  height calc(100% - 140px)
  overflow-y auto
  padding 0 8px

.comment
  padding 4px
  margin 4px 0

.c_name
  margin-bottom 2px
  font-size 12px
  width 100%

.c_created_at
  color darkgray
  font-weight 400
  margin-left 4px

.textarea-block
  border none
  resize none

  &:focus
    box-shadow none

.input-block
  width 234px
  height 100px
  position fixed
  bottom 16px
  margin 8px
  background-color white
  // border: 1px solid lightgray;
</style>
